import React from 'react';
import IndianCuisineApp from './IndianCuisineApp.js';
import { ErrorBoundaryWrapper } from './enhanced.js';

const CulinaryFest = () => (
  <ErrorBoundaryWrapper>
    <IndianCuisineApp />
  </ErrorBoundaryWrapper>
);

export default CulinaryFest;
